import React, { Component } from 'react';

class CreateStationFolderModal extends Component {
    render() {
        const {
            show,
            stationName,
            initialVersion,
            zones,
            stationZone,
            onClose,
            onChange,
            onVersionChange,
            onZoneChange,
            onSubmit,
            isSubmitDisabled
        } = this.props;

        if (!show) return null;

        return (
            <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)", backdropFilter: "blur(2px)" }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0" style={{ borderRadius: '12px' }}>
                        
                        {/* Header */}
                        <div
                            className="modal-header border-0"
                            style={{ background: '#193e6c', color: 'white', borderRadius: '12px 12px 0 0' }}
                        >
                            <h5 className="modal-title">
                                Create Station
                            </h5>
                            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
                        </div>

                        {/* Body */}
                        <div className="modal-body py-4">
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className="form-label text-muted">Station Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={stationName}
                                        onChange={(e) => onChange(e)}
                                        placeholder="Enter station name"
                                        style={{ borderRadius: '6px' }}
                                        onKeyDown={(e) => {
                                            if (e.key === " ") e.preventDefault();
                                        }}
                                    />
                                </div>
                                <div className="col-6">
                                    <label className="form-label text-muted">Zone</label>
                                    <select
                                        className="form-select"
                                        value={stationZone}
                                        onChange={(event) => onZoneChange(event.target.value)}
                                        required
                                        style={{ borderRadius: '6px' }}
                                    >
                                        <option value="" disabled>Select zone</option>
                                        {zones.map((zone) => (
                                            <option key={zone.id} value={zone.name}>{zone.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-6">
                                    <label className="form-label text-muted">Initial Version</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={initialVersion}
                                        onChange={(event) => onVersionChange(event.target.value.replace(/[^\d.]/g, ""))}
                                        inputMode="decimal"
                                        placeholder="Example: 2.0.0"
                                        style={{ borderRadius: '6px' }}
                                    />
                                    {/* <div className="form-text">Use numbers separated by decimals, for example 2.0.0.</div> */}
                                </div>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="modal-footer border-0">
                            <button
                                className="btn btn-light"
                                onClick={onClose}
                                style={{ borderRadius: '6px' }}
                            >
                                Cancel
                            </button>

                            <button
                                className="btn btn-success"
                                onClick={onSubmit}
                                disabled={isSubmitDisabled}
                                style={{ borderRadius: '6px', background: '#193e6c', border: 'none' }}
                            >
                                Create Station
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default CreateStationFolderModal;